import { v4 as uuidv4 } from 'uuid';
import DomainEvent from './domain-event';

export class ProspectEvaluationRequest extends DomainEvent {
  constructor(attributes, metadata) {
    super('creditu.prospect-documents.event.risk-evaluation-requested', new Date());
    const validatedAttributes = attributes;
    if (!attributes.id) {
      validatedAttributes.id = uuidv4();
    }
    this.data.attributes = validatedAttributes;
    this.metadata = metadata;
  }
}
